import React, {useState} from "react";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import {FiMinusCircle} from "react-icons/fi";
import ETable, {CountBadge, EditIconBtn} from "../components/Table";
import ModalSimple from "../components/ModalSimple";
import {apiDecreaseZoneOccupancy} from "./Actions";

const ZONE_TYPE_LABELS = {
    REAL_TICKET_COUNTER: "Podle vstupenky",
    ENTRANCE_COUNTER: "Počítadlo průchodů",
};

const CAPACITY_COLORS = {
    green:  {color: "#16a34a", background: "#f0fdf4", border: "1px solid #bbf7d0"},
    yellow: {color: "#b45309", background: "#fffbeb", border: "1px solid #fde68a"},
    red:    {color: "#dc2626", background: "#fef2f2", border: "1px solid #fecaca"},
};

const CapacityBadge = ({occupancy, capacity}) => {
    let ratio = capacity ? (occupancy ?? 0) / capacity : 0;
    let level = !capacity ? "green" : ratio < 0.6 ? "green" : ratio < 0.8 ? "yellow" : "red";
    return (
        <span style={{...CAPACITY_COLORS[level], borderRadius: "6px", padding: "2px 8px", fontSize: "var(--enigoo-fs-sm)", fontWeight: 700}}>
            {occupancy ?? 0} / {capacity ?? "∞"} ({(ratio * 100).toFixed(2)}%)
        </span>
    );
};

const DecreaseIconBtn = ({onClick}) => (
    <button
        type="button"
        onClick={onClick}
        title={"Snížit počet lidí v zóně"}
        style={{width: "28px", height: "28px", background: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer"}}
    >
        <FiMinusCircle size={13}/>
    </button>
);

const ZoneTable = ({data, setData}) => {
    let user = useSelector((state) => state.user);
    let [decreaseZone, setDecreaseZone] = useState(null);
    let [count, setCount] = useState(1);
    let [saving, setSaving] = useState(false);

    const closeModal = () => {
        setDecreaseZone(null);
        setCount(1);
    };

    const submitDecrease = () => {
        if (!decreaseZone || !count || count < 1) return;
        setSaving(true);
        apiDecreaseZoneOccupancy(user.activeAreal.id, decreaseZone.id, count, () => {
            setSaving(false);
            Toast.success("Počet lidí v zóně upraven.");
            setData && setData(data.map(z => z.id === decreaseZone.id
                ? {...z, occupancy: Math.max(0, (z.occupancy || 0) - count)}
                : z));
            closeModal();
        }, () => {
            setSaving(false);
            Toast.error("Nepodařilo se upravit počet lidí v zóně.");
        });
    };

    const columns = [
        {header: "ID",           key: "id"},
        {header: "Název",        key: "name"},
        {header: "Nadřazená zóna", render: row => row.parentZone?.name},
        {header: "Typ",          render: row => ZONE_TYPE_LABELS[row.type] || "-"},
        {header: "Kapacita",     render: row => <CapacityBadge occupancy={row.occupancy} capacity={row.capacity}/>},
        {header: "Časový limit", key: "timeLimit"},
        {header: "Tarify",       render: row => <CountBadge value={row?.tariffs?.length}/>},
        {header: "Možnosti",     render: row => (
            <div className={"flex flex-row space-x-1"}>
                <EditIconBtn to={"/zone/detail/" + row.id}/>
                {row.type === "ENTRANCE_COUNTER" && <DecreaseIconBtn onClick={() => setDecreaseZone(row)}/>}
            </div>
        )},
    ];

    return (
        <>
            <ETable columns={columns} data={data}/>
            <ModalSimple
                visible={!!decreaseZone}
                close={closeModal}
                accept={submitDecrease}
                title={"Snížit počet lidí v zóně"}
                body={
                    <div className={"flex flex-col space-y-2"}>
                        <p>Zóna: <span className="font-bold">{decreaseZone?.name}</span></p>
                        <div className={"form-label font-bold pb-1"}>Počet osob</div>
                        <input
                            type="number"
                            min={1}
                            disabled={saving}
                            value={count}
                            onChange={e => setCount(Number(e.target.value))}
                            className={"form-control border rounded p-2"}
                        />
                    </div>
                }
            />
        </>
    );
};

export default ZoneTable;
